import { useState } from 'react';
import { Select, Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { projectsApi } from '../../api/endpoints/projects';

interface ProjectSelectProps {
  value?: number | null;
  onChange?: (value: number | undefined) => void;
  placeholder?: string;
  customerId?: number;
  allowClear?: boolean;
}

export function ProjectSelect({
  value,
  onChange,
  placeholder = 'Buscar proyecto…',
  customerId,
  allowClear = true,
}: ProjectSelectProps): JSX.Element {
  const [search, setSearch] = useState('');

  const { data, isFetching } = useQuery({
    queryKey: ['projects', 'lookup', search, customerId],
    queryFn: () =>
      projectsApi.list({
        page: 1,
        pageSize: 20,
        search: search || undefined,
        customerId,
        sortDir: 'asc',
      }),
  });

  const options =
    data?.data.map((p) => ({
      label: p.projectNumber ? `${p.projectNumber} · ${p.name}` : p.name,
      value: p.id,
    })) ?? [];

  return (
    <Select
      showSearch
      allowClear={allowClear}
      placeholder={placeholder}
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? undefined)}
      onSearch={setSearch}
      filterOption={false}
      notFoundContent={isFetching ? <Spin size="small" /> : 'Sin resultados'}
      options={options}
      style={{ width: '100%' }}
    />
  );
}
